import {setColorsInDom, isColorInHexFormat} from "../utils/colorHelper.mjs";
import {notifyError, notifySuccess} from "@ignitesales/neuro-application";

const DialogueActions = {
    THEME_COLORS_UPDATED: 'COLORS_UPDATED',
    THEME_FDIC_UPDATED: 'FDIC_UPDATED',
    THEME_EHL_UPDATED: 'EHL_UPDATED',
    THEME_HIDE_ACTIONS_UPDATED: 'HIDE_ACTIONS_UPDATED',
    THEME_CONFIGURATION_UPDATED: 'CONFIGURATION_UPDATED'
};

const DialogueActionsStorageKeys = {
    THEME_RUNNER_COLORS: 'THEME_RUNNER_COLORS',
    THEME_RUNNER_FDIC: 'THEME_RUNNER_FDIC',
    THEME_RUNNER_EHL: 'THEME_RUNNER_EHL',
    THEME_RUNNER_HIDE_ACTIONS: 'THEME_RUNNER_HIDE_ACTIONS'
};

const setThemeConfiguration = ({ primaryColor, secondaryColor, isFdicMember, isEhlMember, hideActions }) => {
    return async (dispatch) => {
        if( isColorInHexFormat(primaryColor) && isColorInHexFormat(secondaryColor) ) {
            const updatedColors = {
                primaryColor: primaryColor, secondaryColor: secondaryColor
            };
            const updateEhl = {
              isEhlMember
            };
            const updatedFdic = {
              isFdicMember
            };
            const updateHideActions = {
              hideActions
            };
            window.localStorage.setItem(DialogueActionsStorageKeys.THEME_RUNNER_COLORS, JSON.stringify(updatedColors));
            window.localStorage.setItem(DialogueActionsStorageKeys.THEME_RUNNER_FDIC, JSON.stringify(updatedFdic));
            window.localStorage.setItem(DialogueActionsStorageKeys.THEME_RUNNER_EHL, JSON.stringify(updateEhl));
            window.localStorage.setItem(DialogueActionsStorageKeys.THEME_RUNNER_HIDE_ACTIONS, JSON.stringify(updateHideActions));
            setColorsInDom(updatedColors);
            notifySuccess('themeConfigurationUpdated');
            dispatch({
                type: DialogueActions.THEME_CONFIGURATION_UPDATED,
                primaryColor,
                secondaryColor,
                isFdicMember,
                isEhlMember,
                hideActions
            });
        } else {
            notifyError('themeRunnerColorsUpdated');
        }
    };
};

const setThemeRunnerColors = ({ primaryColor, secondaryColor }) => {
    return async (dispatch) => {
        if( isColorInHexFormat(primaryColor) && isColorInHexFormat(secondaryColor) ) {
            const updatedColors = {
                primaryColor: primaryColor, secondaryColor: secondaryColor
            };
            window.localStorage.setItem(DialogueActionsStorageKeys.THEME_RUNNER_COLORS, JSON.stringify(updatedColors));
            setColorsInDom(updatedColors);
            notifySuccess('themeRunnerColorsUpdated');
            dispatch({
                type: DialogueActions.THEME_COLORS_UPDATED, primaryColor, secondaryColor
            });
        } else {
            notifyError('themeRunnerColorsUpdated');
        }
    };
};

const setThemeRunnerFdic = (isFdicMember) => {
  return async (dispatch) => {
      const updatedFdic = {
        isFdicMember
      };
      window.localStorage.setItem(DialogueActionsStorageKeys.THEME_RUNNER_FDIC, JSON.stringify(updatedFdic));
      notifySuccess('themeRunnerFdicUpdated');
      dispatch({
          type: DialogueActions.THEME_FDIC_UPDATED, isFdicMember
      });
  };
};

const setThemeRunnerEhl = (isEhlMember) => {
  return async (dispatch) => {
      const updatedEhl = {
        isEhlMember
      };
      window.localStorage.setItem(DialogueActionsStorageKeys.THEME_RUNNER_EHL, JSON.stringify(updatedEhl));
      notifySuccess('themeRunnerEhlUpdated');
      dispatch({
          type: DialogueActions.THEME_EHL_UPDATED, isEhlMember
      });
  };
};

const setThemeRunnerHideActions = (hideActions) => {
  return async (dispatch) => {
      const updatedHideActions = {
        hideActions
      };
      window.localStorage.setItem(DialogueActionsStorageKeys.THEME_RUNNER_HIDE_ACTIONS, JSON.stringify(updatedHideActions));
      notifySuccess('themeRunnerHideActionsUpdated');
      dispatch({
          type: DialogueActions.THEME_HIDE_ACTIONS_UPDATED, hideActions
      });
  };
};


export {
    DialogueActions,
    DialogueActionsStorageKeys,
    setThemeConfiguration,
    setThemeRunnerColors,
    setThemeRunnerFdic,
    setThemeRunnerEhl,
    setThemeRunnerHideActions
};
